<template>
  <div v-show="visible">
    <!-- MAIN -->
    <div class="list-analytics analysis-chart">
      <div :class="['t-chart', { 'c-pointer': existSubCharts }]">
        <div v-if="existSubCharts" class="title corner" @click="onShowSubChartButtonClick">
          {{ mainChart.name }}
          <div :class="addButtonIconName"></div>
        </div>
        <div v-else class="title">{{ mainChart.name }}</div>
        <w-plot-area-chart v-if="mainChart.type === 'area'" ref="mainChart" :active="active" :visible="visible" :rscInfoList="mainChart.rscInfoList" @clickChart="onClickChart" />
        <w-plot-line-chart v-else ref="mainChart" :active="active" :visible="visible" :rscInfoList="mainChart.rscInfoList" @clickChart="onClickChart" />
      </div>
    </div>
    <!-- SUB -->
    <div v-if="existSubCharts && showSubCharts" class="sub-chart-wrapper">
      <div class="list-analytics analysis-chart" v-for="subChart in subCharts" :key="subChart.id">
        <div class="t-chart">
          <div class="title">{{ subChart.name }}</div>
          <w-plot-area-chart v-if="subChart.type === 'area'" :ref="`${subChart.id}Chart`" :active="active" :visible="showSubCharts" :rscInfoList="subChart.rscInfoList" @clickChart="onClickChart" />
          <w-plot-line-chart v-else :ref="`${subChart.id}Chart`" :active="active" :visible="showSubCharts" :rscInfoList="subChart.rscInfoList" @clickChart="onClickChart" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PerformanceAnalysisChartMixin from './mixins/performance-analysis-chart';

export default {
  name: 'WPerformanceAnalysisChart',
  mixins: [PerformanceAnalysisChartMixin],
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/components/PerformanceAnalysisChartView/PerformanceAnalysisChart.vue